import React from 'react';
import { ListPageScaffold } from '../../components/common/list-page';
import Statistics from '../../components/reports/Statistics/Statistics';

const StatisticsPage: React.FC = () => {
  return (
    <ListPageScaffold>
      <Statistics />
    </ListPageScaffold>
  );
};

export default StatisticsPage;
